// @ts-nocheck
import { Checkbox } from "@shared/antd/checkbox";
import { Input } from "@shared/antd/input";
import { Select } from "@shared/antd/select";
import { Icon } from "@shared/antd/icon";
import React, { useEffect, useState } from "react";
import { ButtonComponent } from "../ui";
import { FormattedMessage, IntlShape } from "react-intl";
import { FilterDropdownProps } from "antd/lib/table/interface";
import { get } from "app/shared/lodash/lodash";

interface FormFilterProps<T> {
  data: T[];
  intl: IntlShape;
}

type contentReturn<T> = {
  content: (
    props: FilterDropdownProps,
    key: string,
    title: string,
  ) => JSX.Element;
  filteringArray: T[];
};

type FilterType<T> = {
  item: T;
  key: string;
};
const options = [
  { value: "contain", label: "Содержит" },
  { value: "equals", label: "=" },
  { value: "lt", label: "<" },
  { value: "gt", label: ">" },
];

export function useFormFilterHook<T>(
  arg: FormFilterProps<T>,
): contentReturn<T> {
  const { data = [], intl } = arg;
  const [filteringArray, setFilteringArray] = useState<T[]>([]);
  const [filterString, setFilterString] = useState<any>({});
  const [filterByAll, setFilterByAll] = useState<boolean>(false);
  const [typeRule, setTypeRule] = useState<string>(options[0].value || "");
  const containIn = (props: FilterType<T>) => {
    const { item, key } = props;

    if (
      get(item, key) === false ||
      !filterString[key] ||
      !filterString[key]?.value
    )
      return -1;
    const filterS = filterString[key].value;

    if (typeof get(item, key) === "string") {
      return get(item, key)?.toLowerCase().includes(filterS.toLowerCase());
    }
    if (typeof get(item, key) === "number") {
      return get(item, key) === Number(filterS);
    }
    return -1;
  };
  const equals = (props: FilterType<T>) => {
    const { item, key } = props;
    if (
      get(item, key) === false ||
      !filterString[key] ||
      !filterString[key]?.value
    )
      return -1;

    const filterS = filterString[key].value;
    if (typeof get(item, key) === "string") {
      return get(item, key)?.toLowerCase() === filterS.toLowerCase();
    }
    if (typeof get(item, key) === "number") {
      return Number(get(item, key)) === Number(filterS);
    }
    return -1;
  };
  const filterLt = (props: FilterType<T>) => {
    const { item, key } = props;
    if (
      get(item, key) === false ||
      !filterString[key] ||
      !filterString[key]?.value
    )
      return -1;
    const filterS = filterString[key].value;
    if (typeof Number(get(item, key)) === "number") {
      return Number(get(item, key)) < Number(filterS);
    }
    return -1;
  };
  const filterGt = (props: FilterType<T>) => {
    const { item, key } = props;

    if (get(item, key) === false || !filterString[key]) return -1;

    const filterS = filterString[key].value;

    if (typeof Number(get(item, key)) === "number") {
      return Number(get(item, key)) > Number(filterS);
    }
    return -1;
  };

  const rules = {
    contain: containIn,
    equals: equals,
    lt: filterLt,
    gt: filterGt,
  };
  const filterRules = (item: T, key: string, type?: string) => {
    if (type) {
      return rules[type]({ item, key });
    }
    if (rules[typeRule]) {
      return rules[typeRule]({ item, key });
    }
    return -1;
  };
  const onFiltering = (key: string) => {
    if (get(filterString, key) === undefined) {
      setFilteringArray(data);
      return null;
    }

    if (filterByAll && filteringArray.length) {
      let arr = data;
      const keys = Object?.keys(filterString);
      if (!keys) return null;
      keys.map(
        (key: any) =>
          (arr = arr.filter((item) => {
            return filterRules(item, key, filterString[key]?.typeSort);
          })),
      );

      setFilteringArray(arr);
      return arr;
    }

    const result = data.filter((item) => {
      return filterRules(item, key);
    });

    setFilteringArray((prevState) => result);

    return result;
  };

  const onResetFilter = (key: string) => {
    setFilteringArray(data);
    setFilterString({});
    // setFilterString((prev: any) => ({
    //     ...prev,
    //     [key]: ''
    //   })
    // )
  };
  const handleChangeType = (value: string) => {
    setTypeRule(value);
  };

  const deleteOneParam = (key: string) => {
    setFilterString((prevState: any) => {
      const newObj = { ...prevState };
      delete newObj[key];
      return newObj;
    });
  };
  const renderParams = () => {
    if (!filterString) return null;
    const keys = Object?.keys(filterString);
    if (!keys) return null;
    return keys.map(
      (key) =>
        filterString[key]?.value && (
          <div className={"flex justify-between"} key={key}>
            <div className={"flex gap-4"}>
              <span className={"font-bold"}>
                {intl.formatMessage({ id: filterString[key]?.title })}:
              </span>
              <span className={"font-bold"}>
                {
                  options?.filter(
                    (option) => option.value === filterString[key]?.typeSort,
                  )[0]?.label
                }
              </span>
              <span className={"text-active-blue"}>
                {filterString[key]?.value}
              </span>
            </div>
            <ButtonComponent
              className={"text-red-600 hover:bg-active-blue p-1"}
              onClick={() => deleteOneParam(key)}
            >
              <Icon type="delete" />
            </ButtonComponent>
          </div>
        ),
    );
  };
  const content = (props: FilterDropdownProps, key: string, title: string) => {
    return (
      <div className={"p-4"}>
        <div className={"flex gap-2 justify-center items-center mb-2"}>
          <div>{intl.formatMessage({ id: title })}:</div>
          <Select
            className={"w-32"}
            placeholder="Выберите значение"
            onChange={handleChangeType}
            value={typeRule}
          >
            {options.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
          <Input
            className={"max-w-32"}
            onChange={(e) => {
              setFilterString((prev: any) => ({
                ...prev,
                [key]: {
                  ...prev[key],
                  typeSort: typeRule,
                  value: e.target.value,
                  title,
                },
              }));
            }}
            value={get(filterString, key)?.value || ""}
          />
        </div>
        <div className={"flex flex-col gap-2 mb-2"}>{renderParams()}</div>
        <Checkbox
          className={"mb-2 flex justify-end"}
          name="enableContains"
          checked={filterByAll}
          onChange={() => setFilterByAll((prevState) => !prevState)}
        >
          Фильтровать по всем
        </Checkbox>
        <div className={"flex gap-2 justify-end "}>
          <ButtonComponent
            className={
              "px-2 py-1 bg-active-light hover:bg-active-dark text-white"
            }
            onClick={() => onFiltering(key)}
          >
            <FormattedMessage id={"org.request.filter"} />
          </ButtonComponent>
          <ButtonComponent
            className={
              "px-2 py-1 bg-active-light hover:bg-active-dark text-white"
            }
            onClick={() => onResetFilter(key)}
          >
            <FormattedMessage id={"cubaReact.dataTable.clearAllFilters"} />
          </ButtonComponent>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setFilteringArray(data);
  }, [data]);
  return {
    filteringArray,
    content: content,
  };
}
